import React, {useState, useEffect} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import LinkRow from '../components/LinkRow';
import {useHistory} from 'react-router-dom';
import {functions} from "../../../constants/common-functions";
import {TRUE} from "../../../constants/general-constants";


export default function ListPanel({headerTitle, headerDescription, restUrl, adminPage, isResources}){
	
	const history = useHistory(); 
	const [listResults, setListResults] = useState([]);
	const [likeString, setLikeString] = useState("");
	
	useEffect(() => {
		try{
			if(isResources === TRUE){
				
				functions.getArrayFromAjax("/resolutionsoftwareplatform/" + restUrl + "?search=", setListResults, analyseThis);
			}
			else{
				functions.getArrayFromAjax("/resolutionsoftwareplatform/" + restUrl + "?like=", setListResults, null);
			}
		}
		catch(e){
			functions.getArrayFromAjax("/resolutionsoftwareplatform/admin/list/" + restUrl + "?like=" + likeString + "=&page=0", setListResults, null);
		}
		
	}, [restUrl]);
	
	const analyseThis = (results) => {
		
		let tempListResults = [];
		for(let i=0; i<results.length; i++){
			tempListResults.push({
				id:results[i].id,
				name:results[i].filename,
				description:results[i].title
			})
		}
		
		setListResults(tempListResults);
	};
	
	const thisContainer = {
	    display:"flex",
	    flexDirection:"column",
	    marginLeft:"10px",
	    width:'100%',
	    flex:1,
	    minHeight:0
	};
	
	const searchPanel = {
		display:"flex",
		width:"calc(100% - 100px)",
		backgroundColor:"lightgrey",
		padding:"20px",
		marginLeft:"30px",
		borderTopLeftRadius:"4px",
		borderTopRightRadius:"4px"
	};
	
	const searchBox = {
		display:"flex",
		height:"30px",
		border:"1px solid white",
		borderRadius:"22px",
		width:"calc(100% - 0px)",
		justifyContent:"space-between"
	};
	
	const searchText ={
		width:"calc(100% - 80px)",
		fontSize:"14px",
		color:"black",
		border:"0px",
		backgroundColor:"rgba(0,0,0,0)",
		height:"30px",
		marginLeft:"20px",
		marginTop:"5px"
	};
	
	const searchIconContainer = {
		display:"flex",
		width:"26px",
		height:"26px",
		borderRadius:"20px",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		margin:"2px"
	};
	
	const searchIconStyle = {
		display:"flex",
		width:"15px",
		height:"15px",
		color:"white"
	};
	
	
	const columnHeader = {
		display:"flex",
		height:"30px",
		backgroundColor:"black",
		width:"calc(100% - 60px)",
		alignItems:"center",
		marginLeft:"30px"	
	};
	
	const titleColumn = {
		display:"flex",
		color:"white",
		fontSize:"14px",
		paddingLeft:"20px",
		width:"300px"
	};
	
	const descriptionColumn = {
		display:"flex",
		color:"white",
		fontSize:"14px",
		paddingLeft:"20px",
		width:"300px"
	};
	
	const clickFunction = (id) => {
		history.push('/' + adminPage + "/" + id);
	};
	
	const linkPanel = {
	    display:"flex",
	    width:"calc(100% - 60px)",
	    marginLeft:"30px",
	    flexDirection:"column",
	    overflowY:"auto",
	    marginTop:"10px",
	    flex:1,
	    minHeight:0
	};
	
	const listDisplay = listResults.map((item, index) => 
		<LinkRow
			index={index}
			id={item.id}
			title={item.name}
			description={item.description}
			clickFunction={clickFunction}
		/>
	);
	
	return (
		<div style={thisContainer}>	
				<div style={searchPanel}>
					<div style={searchBox}>
						<input type="text" style={searchText}/>
						<div style={searchIconContainer}>
							<FontAwesomeIcon icon="search" style={searchIconStyle}/>
						</div>
					</div>
				</div>
				<div style={columnHeader}>
					<div style={titleColumn}>
						{headerTitle}
					</div>
					<div style={descriptionColumn}>
						{headerDescription}
					</div>
				</div>
				<div style={linkPanel}>
					{listDisplay}
				</div>
		</div>
		
	);
}